// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Журнал контактів» (Contact Log, ключ `clg`, група `advocacy`). */
export const contactLogManifest: IModuleManifest = {
  key: 'clg',
  group: 'advocacy',
  slug: 'contact-log',
  prefix: 'CLG',
  name: { en: 'Contact Log', uk: 'Журнал контактів' },
  entities: [
    { key: 'clg', slug: 'clg', name: { en: 'Contact Log', uk: 'Журнал контактів' }, main: true },
    { key: 'contact_participant', slug: 'contact-participant', name: { en: 'Contact Participants', uk: 'Учасники' }, main: false },
    { key: 'contact_topic', slug: 'contact-topic', name: { en: 'Contact Topics', uk: 'Теми' }, main: false },
    { key: 'contact_declaration', slug: 'contact-declaration', name: { en: 'Contact Declarations', uk: 'Декларації' }, main: false },
  ],
  loadState: () => import('./state/contactLogSlice').then((m) => m.contactLogSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
